import { render } from "./UserManagementAdvancedSearch.vue?vue&type=template&id=20ba0c3e&scoped=true"
import script from "./UserManagementAdvancedSearch.vue?vue&type=script&lang=js"
export * from "./UserManagementAdvancedSearch.vue?vue&type=script&lang=js"

import "./UserManagementAdvancedSearch.vue?vue&type=style&index=0&id=20ba0c3e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-20ba0c3e"

export default script